import React, { useState } from 'react';
import { SERVIDOR } from '../../config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (!formData.username || !formData.password) {
        throw new Error('Por favor, complete todos los campos');
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log('Datos enviados:', formData);

      const response = await axios.post(SERVIDOR+'/api/login-admin', {
        email: formData.username,
        password: formData.password
      });

      const data = response.data;
      console.log('respuesta', data);
      
      if(data.ok){
        localStorage.setItem('adminToken', data.adminToken);
        // Redirigir al panel de administración
        navigate('/AdminUsersPanel');
      } else {
        alert('Usuario o contraseña incorrectos');
        navigate('/LoginAdmin');
      }

    } catch (err) {
      setError(err.message);
      navigate('/LoginAdmin');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="user-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="white"/>
              <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" fill="white"/>
            </svg>
          </div>
          <h1>Bienvenido</h1>
          <p>Ingrese sus credenciales para acceder al sistema</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Nombre de usuario</label>
            <div className="input-wrapper">
              <input
                id="username"
                name="username"
                type="text"
                placeholder="Ingrese su usuario"
                value={formData.username}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="input-wrapper">
              <input
                id="password"
                name="password"
                type='password'
                placeholder="Ingrese su contraseña"
                value={formData.password}
                onChange={handleChange}
              />
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Iniciar Sesión'}
          </button>

          <div className="forgot-password">
          </div>
        </form>
      </div>

      <style jsx>{`
        .login-container {
          min-height: 100vh;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 8rem 1rem 1rem;
          background-color: #f5f5f5;
        }

        .login-card {
          width: 100%;
          max-width: 400px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          position: relative;
          overflow: hidden;
        }

        .login-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background-color: #697565;
        }

        .login-header {
          padding: 2rem;
          text-align: center;
        }

        .user-icon {
          width: 64px;
          height: 64px;
          background-color: #697565;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
        }

        h1 {
          color: #697565;
          font-size: 1.5rem;
          margin: 0 0 0.5rem;
        }

        p {
          color: #666;
          margin: 0;
        }

        form {
          padding: 0 2rem 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        label {
          display: block;
          margin-bottom: 0.5rem;
          color: #333;
          font-weight: 500;
        }

        .input-wrapper {
          position: relative;
        }

        input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        input:focus {
          outline: none;
          border-color: #697565;
          box-shadow: 0 0 0 2px rgba(105, 117, 101, 0.1);
        }

        .error-message {
          background-color: #fee2e2;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 4px;
          margin-bottom: 1rem;
          font-size: 0.875rem;
        }

        .submit-button {
          width: 100%;
          padding: 0.75rem;
          background-color: #697565;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .submit-button:hover {
          background-color: #596555;
        }

        .submit-button:disabled {
          background-color: #9ca3af;
          cursor: not-allowed;
        }

        .forgot-password {
          text-align: center;
          margin-top: 1rem;
        }

        .forgot-password a {
          color: #697565;
          text-decoration: none;
          font-size: 0.875rem;
        }

        .forgot-password a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
};

export default LoginForm;